<template>
  <form v-if="value">
    <div class="row">
      <string-form-field
        class="col-md-6"
        label="Nome interno"
        :value="value.internalName"
        :disabled="disabled"
        :error="findError('internalName')"
        @input="propertyChanged('internalName', $event)"
      />

      <string-form-field
        class="col-md-6"
        label="Titolo"
        :value="value.title"
        :disabled="disabled"
        :error="findError('title')"
        @input="propertyChanged('title', $event)"
      />
    </div>
  </form>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';

export default {
  mixins: [ EntityEditorMixin ],
}
</script>
